import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Flame } from "lucide-react";

const HEAT = { hot: "text-rose-300 bg-rose-400/10 border-rose-400/30", warm: "text-amber-300 bg-amber-400/10 border-amber-400/30", emerging: "text-cyan-300 bg-cyan-400/10 border-cyan-400/30" };

export function useDemand() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/franchise/demand").then((r) => setD(r.data)).catch(() => setD({ metros: [] })); }, []);
  return d;
}

export default function DemandRanking({ demand, onPick, limit = 8 }) {
  if (!demand) return null;
  const top = demand.metros.slice(0, limit);
  return (
    <div className="rounded-2xl border border-slate-800 bg-[#131722] p-4 space-y-2" data-testid="demand-ranking">
      <p className="font-mono text-[10px] uppercase tracking-widest text-rose-300 flex items-center gap-1.5"><Flame className="w-3.5 h-3.5" />Demand ranking · last 90 days</p>
      {top.map((m, i) => <button key={m.territory_id} type="button" onClick={() => onPick?.(m)} className="w-full flex items-center gap-3 text-left hover:bg-slate-800/50 rounded-lg px-2 py-1.5 transition-colors" data-testid={`demand-row-${m.territory_id}`}>
        <span className="font-mono text-xs text-slate-500 w-5">{i + 1}</span>
        <span className="flex-1 min-w-0"><span className="text-sm font-semibold">{m.metro}, {m.state}</span><span className="block text-[11px] text-slate-400">{m.searches} searches · {m.bookings} bookings · {m.cars} cars · {m.gigs} gigs · {m.leads} leads</span></span>
        <span className="w-24 h-1.5 rounded bg-slate-800 overflow-hidden hidden sm:block"><span className="block h-full bg-gradient-to-r from-cyan-400 via-amber-300 to-rose-400" style={{ width: `${Math.max(4, m.score)}%` }} /></span>
        <span className={`px-2 h-5 rounded-full border text-[10px] font-mono uppercase flex items-center ${HEAT[m.heat]}`} data-testid={`demand-heat-${m.territory_id}`}>{m.heat} {m.score}</span>
      </button>)}
      <p className="text-[10px] text-slate-500">Score = searches×1 + paid bookings×8 + listed cars×3 + gig posts×4 + inquiries×5, scaled to the strongest metro.</p>
    </div>
  );
}
